import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const Gauge = ({ typeKey, dataField, setDataField, fieldOptions, error }) => {
  const {
    iotOrderDetailsSection: {
      nssFarmAndRanchTankDetailsLabel: { tankGauge }
    },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldHasError = error && !dataField.valueTankGauge;

  useEffect(() => {
    if (fieldOptions.length === 1 && !dataField.valueTankGauge) {
      setDataField(previousValue => ({
        ...previousValue,
        valueTankGauge: fieldOptions[0]
      }));
    }
  }, [dataField]);

  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankGauge}
        items={radioItems}
        checkedId={dataField.valueTankGauge || (fieldOptions.length === 1 ? fieldOptions[0] : null)}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankGauge: value
        })}
        name={`${typeKey}--gauge`}
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      <Spacer space={2} />
    </>
  );
};

Gauge.propTypes = {
  typeKey: PropTypes.string.isRequired,
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankGauge: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  fieldOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  error: PropTypes.string.isRequired
};

export default Gauge;
